<template>
  <v-container grid-list-xl text-xs-center>
    <v-layout v-if="loading">
      <v-flex>
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 sm12>
        <div>
          <v-card>
            <v-card-title>
              Tomar asistencia cita
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="quoteData"
              :search="search"
              :loading="loadingTable"
            >

              <template slot="items" slot-scope="props"
              >
                <td class="text-xs-center">{{ props.item.schedule_start_date }}</td>
                <td class="text-xs-center">{{ props.item.schedule_start_time | formatHour }}</td>
                <td class="text-xs-center">{{ props.item.schedule_end_date }}</td>
                <td class="text-xs-center">{{ props.item.schedule_end_time | formatHour }}</td>
                <td class="text-xs-center" v-if="props.item.status==1">Sin asistencia</td>
                <td class="text-xs-center" v-else-if="props.item.status==2">Cumplida</td>
                <td class="text-xs-center" v-else-if="props.item.status==0">Sin Tomar</td>
                <td class="text-xs-center">{{ props.item.name }}</td>
                <td class="text-xs-center">
                  <v-tooltip top>
                    <v-icon
                      :disabled="props.item.status==2 || props.item.status==0"
                      medium
                      class="mr-2"
                      @click="takeSchedule(props.item, ifTake=true)"
                      slot="activator"
                    >
                      done
                    </v-icon>
                    <span>Ir a cita</span>

                  </v-tooltip>
                </td>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>

          </v-card>
        </div>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 sm6 md6 v-if="signatureEvent">
        <v-card>
          <v-card-title class="primary font-weight-bold white--text">Firma:</v-card-title>
          <VueSignaturePad
            width="450px"
            height="200px"
            ref="signaturePad"
          />
          <v-card-actions>
            <v-btn medium @click="save" :disabled="loading" color="primary">Guardar</v-btn>
            <v-btn medium @click="undo" >Deshacer</v-btn>
            <v-btn medium @click="clear" >Limpiar</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 sm5 md6 offset-xs0 v-show="ifTake">
        <v-card elevation-10>
          <v-card-title class="subheading font-weight-bold primary white--text">Chequeo asistentes a la agenda de las: <b>{{event.schedule_start_time | formatHour}}</b></v-card-title>
          <v-list dense>
            <v-list-tile v-if="parents=='father' || parents=='Ambos'">
              <v-checkbox
                :disabled="form.delegate_allowed || form.external_families"
                name="assistFather"
                v-model="form.assistFather"
              ></v-checkbox>
              <v-list-tile-content class="font-weight-bold">Padre:</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">{{ parents.father }}</v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="parents=='mother' || parents=='Ambos'">
              <v-checkbox
                :disabled="form.delegate_allowed || form.external_families"
                name="assistMother"
                v-model="form.assistMother"
              ></v-checkbox>
              <v-list-tile-content class="font-weight-bold">Madre:</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">{{ parents.mother }}</v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-show="event.delegate_allowed == 1">
              <v-checkbox
                class="check"
                :disabled="form.assistFather || form.assistMother"
                name="delegate_allowed"
                v-model="form.delegate_allowed"
              ></v-checkbox>
              <v-list-tile-content class="font-weight-bold">Delegado</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-show="event.delegate_allowed == 1">
              <v-checkbox
                class="check"
                :disabled="form.assistFather || form.assistMother"
                name="external_families"
                v-model="form.external_families"
              ></v-checkbox>
              <v-list-tile-content class="font-weight-bold">¿Externo?</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-card-text>
            <text-input
              v-show="form.delegate_allowed"
              :form="form"
              v-model="form.delegate"
              label="Delegado"
              error-messages="messageValidate.delegateMessage"
              :v-errors="errors"
              :value.sync="form.delegate"
              counter="100"
              name="delegate"
              v-validate="'max:100|'"
            ></text-input>
            <div class='red--text'>{{messageValidate.delegateMessage}}</div>
            <text-input
              v-show="form.delegate_allowed"
              :form="form"
              v-model="form.delegated_kinship"
              label="Parantesco delegado"
              :v-errors="errors"
              :value.sync="form.delegated_kinship"
              :error-messages="messageValidate.delagateMessage"
              counter="30"
              name="delegate"
              v-validate="'max:30|'"
            ></text-input>
            <div class='red--text'>{{messageValidate.delegated_kinship}}</div>
            <text-input
              :form="form"
              v-model="form.observation"
              label="Observación"
              :v-errors="errors"
              :value.sync="form.observation"
              counter="100"
              name="observation"
              v-validate="'max:100|'"
            ></text-input>
          </v-card-text>
          <v-card-actions>
            <v-btn v-show="!event.requires_signature" @click="save()" color="green darken-1" >Tomar asistencia</v-btn>
            <v-btn v-show="event.requires_signature" @click="signatureEvent=true" color="yellow darken-1" >Firmar evento</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

    </v-layout>

  </v-container>
</template>

<script>
import formatHour from "../../libs/filter"
import Form from 'vform';
import axios from 'axios';
    export default {
        name: "ScheduleTakeAssistance",
        data () {
            return {
                ifTake: false,
                messageValidate: {
                    delegateMessage: '',
                    delegated_kinship: ''
                },
                form: new Form({
                    schedule_id: null,
                    assistMother: false,
                    assistFather: true,
                    signatureUrl: null,
                    delegate: null,
                    delegate_allowed: false,
                    external_families: false,
                    observation: null
                }),
                parents: [],
                event: [],
                loadingTable: false,
                loading: false,
                search: '',
                signatureEvent: false,
                quoteData: [],
                headers: [
                    { text: 'Fecha inicio', align: 'center', value: 'schedule_start_date' },
                    { text: 'Hora inicio', align: 'center', value: 'schedule_start_time' },
                    { text: 'Fecha fin', align: 'center', value: 'schedule_end_date' },
                    { text: 'Hora fin', align: 'center', value: 'schedule_end_time' },
                    { text: 'Estado', align: 'center', value: 'status' },
                    { text: 'Nombre', align: 'center', value: 'name' },
                    { text: 'Acción', align: 'center', value: 'id', sortable: false }
                ],
            }
        },
        methods: {
            save (){
                if(this.signatureEvent){
                    if(this.$refs.signaturePad.saveSignature().isEmpty){
                        return;
                    }
                    this.form.signatureUrl = this.$refs.signaturePad.saveSignature().data

                }
                if(this.form.delegate_allowed) {
                    if (this.form.delegate == '')  {
                        this.messageValidate.delegateMessage = 'Este campo es obligatorio';
                        return true;
                    }
                    if (this.form.delegated_kinship == '')  {
                        this.messageValidate.delegated_kinship = 'Este campo es obligatorio'
                        return;
                    }
                }
                let data = {
                    schedule_id: this.form.schedule_id,
                    assistMother: this.form.assistMother,
                    assistFather: this.form.assistFather,
                    signatureUrl: this.form.signatureUrl,
                    delegate: this.form.delegate,
                    delegate_allowed: this.form.delegate_allowed,
                    external_families: this.form.external_families,
                    observation: this.form.observation
                }
                axios.post('/api/take/schedule/assitance', data)
                    .then(resp=>{
                        if(resp.data.status==201){
                            this.getQuote()
                            this.ClearSchedule()
                            this.$store.dispatch('responseMessage', {
                                type: 'success',
                                text: this.$t('Cita cumplida con éxito'),
                                title: this.$t('Registrado'),
                                modal: true
                            })
                        }else{
                            this.$store.dispatch('responseMessage', {
                                type: 'error',
                                text: this.$t('Se produjo un error, intente de nuevo'),
                                title: this.$t('Alerta'),
                                modal: true
                            })
                        }
                    }).catch(error=>{
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: this.$t('Se producjo un error, intente de nuevo'),
                        title: this.$t('Alerta'),
                        modal: true
                    })
                })
            },
            takeSchedule (item) {
                this.event = item;
                this.parents  = item.parents
                this.form.schedule_id = item.id
            },
            ClearSchedule () {
                this.signatureEvent = false;
                this.event = [];
                this.parents  = []
                this.form.schedule_id = null
            },
            undo() {
                this.$refs.signaturePad.undoSignature();
            },
            clear() {
                this.$refs.signaturePad.clearSignature();
            },
            getQuote () {
              
                this.loading = true;
                this.loadingTable = true;
                axios.get('/api/schedule/by/quote/' + this.$route.params.id).then(resp=>{
                  console.log(resp.data)
                    this.quoteData = resp.data.data
                    this.loadingTable = false;
                    this.loading = false;
                }).catch(error=>{
                    this.loading = false;
                    this.loadingTable = false;
                })
            }
        },
        mounted() {
            this.getQuote()
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/shedule/ScheduleTakeAssistance.vue